import { render } from "./GnbArea.vue?vue&type=template&id=6e6b8886"
import script from "./GnbArea.vue?vue&type=script&lang=js"
export * from "./GnbArea.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\prj\\asan\\asan_tpps_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__